import http from '../../utils/fetch';
export default {

    baseurl:'/api/swyl/v1/demo/bscClueOwner',

    selectById(query){
        return http({
            url: this.baseurl + '/selectById',
            method: 'post',
            params: query
        });
    },

    updateById(query){
        return http({
            url: this.baseurl + '/updateById',
            method: 'post',
            params: query
        });
    },
    deleteById(query){
        return http({
            url: this.baseurl + '/deleteById',
            method: 'post',
            params: query
        });
    },



    sendMsg(){
        return http.post(this.baseurl + '/sendMsg');
    },
    querySmsSendDetail(){
        return http.post(this.baseurl + '/querySmsSendDetail');
    },


    getwlzhaobiao(query){

        return http({
            url: this.baseurl+'/getwlzhaobiao',
            method: 'post',
            params: query
        });

    },


    selectPage(query){
        return http({
            url: this.baseurl + '/selectPage',
            method: 'post',
            params: query
        });
    },


    insert(query){
        return http({
            url: this.baseurl + '/insert',
            method: 'post',
            params: query
        });
    },

    selectClueOwner(query){
        return http({
            url: this.baseurl+'/selectClueOwner',
            method: 'post',
            params: query
        });
    },




}
